// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PersonName {
    static getAttributeTypeMap() {
        return PersonName.attributeTypeMap;
    }
}
PersonName.discriminator = undefined;
PersonName.additionalProperties = false;
PersonName.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "prefix",
        "baseName": "prefix",
        "type": "string"
    },
];
//# sourceMappingURL=personName.js.map